import { system } from '../config/system'

import { browserRedirect, setRedirectUrl } from './browser'

export const gotoLogin = () => {
  const redirectUrl = setRedirectUrl(system.router.loginUrl)
  browserRedirect(redirectUrl)
}
